import { CheckoutDto, CheckoutResponseDto } from './dtos/checkout.ts';
import { LinksRequestDto, LinksResponseDto } from './dtos/links.ts';
import { UpdateCampaignAssetDto, UpdateCampaignAssetResponseDto } from './dtos/updateCampaignAsset.ts';
import { UpdateCampaignMainInfoDto, UpdateCampaignMainInfoResponseDto } from './dtos/updateCampaignMainInfo.ts';
import { UpdatePlaylistsDto, UpdatePlaylistsResponseDto } from './dtos/updatePlaylists.ts';
import { UpdateStatusDto, UpdateStatusResponseDto } from './dtos/updateStatus.ts';

// deno-lint-ignore no-namespace
export namespace EdgeFunctions {

    // also should be used as function name
    export enum Types {
        Checkout = 'checkout',
        Links = 'links',
        UpdateStatus = 'update-status',
        UpdatePlaylists = 'update-playlists',
        UpdateCampaignAsset = 'update-campaign-asset',
        UpdateCampaignMainInfo = 'update-campaign-main-info',
    }

    const Mappings = {
        [Types.Checkout]: tp<CheckoutDto, CheckoutResponseDto>(input => CheckoutDto.createValidation().validate(input)),
        [Types.Links]: tp<LinksRequestDto, LinksResponseDto>(input => LinksRequestDto.createRequestValidation().validate(input)),
        [Types.UpdateStatus]: tp<UpdateStatusDto, UpdateStatusResponseDto>(input => UpdateStatusDto.createValidation().validate(input)),
        [Types.UpdatePlaylists]: tp<UpdatePlaylistsDto, UpdatePlaylistsResponseDto>(input => UpdatePlaylistsDto.createValidation().validate(input)),
        [Types.UpdateCampaignAsset]: tp<UpdateCampaignAssetDto, UpdateCampaignAssetResponseDto>(input => UpdateCampaignAssetDto.createValidation().validate(input)),
        [Types.UpdateCampaignMainInfo]: tp<UpdateCampaignMainInfoDto, UpdateCampaignMainInfoResponseDto>(input => UpdateCampaignMainInfoDto.createValidation().validate(input)),
    } as const;

    function tp<TIn, TOut>(inputValidation?: (input: TIn) => Promise<Partial<TIn> | void>) {
        return {
            in: null as TIn,
            out: null as TOut,
            inputValidation,
        };
    }

    export type Input<T extends Types> = typeof Mappings[T]['in'];
    export type Output<T extends Types> = typeof Mappings[T]['out'];
}
